import Page, {
  Props,
} from "gui/MyFavoriteDashboardsPage/MyFavoriteDashboardsPage";
import type { GetStaticProps } from "next";

import { fetchTags } from "lib/tags/tags";

import behindLogin from "gui/behindLogin/behindLogin";

export default behindLogin(Page);

export const getStaticProps: GetStaticProps<
  Omit<Props, "session">
> = async () => {
  const tags = await fetchTags("dashboards", 20, 0);

  return {
    props: { tags },
    revalidate: 2 * 60, // 2 minute cache
  };
};
